module.exports = __webpack_public_path__ + "static/media/cert_123.099dba6b.jpg";